<div class="aa-shell" [class.nav-open]="navOpen">
  <div class="aa-sidebar">
    <div class="aa-logo">
      @if (!logoFailed) {
      <div class="aa-logo-plate">
        <img src="assets/images/avatar-academy-logo.png" alt="Avatar Academy" (error)="logoFailed = true"
          routerLink="/dashboard" />
      </div>
      }
      <div class="aa-logo-fallback" [style.display]="logoFailed ? 'block' : 'none'">
        <div class="aa-logo-mark">AVATAR<br />ACADEMY</div>
      </div>
    </div>
    <div class="aa-nav">
      @for (item of navItems; track item) {
      <a class="aa-nav-item" [class.active]="activeNavItem === item.id" [routerLink]="item.route">
        <svg class="icon">
          <use [attr.href]="'#' + item.icon"></use>
        </svg>{{ item.label }}
      </a>
      }
    </div>
    <div class="aa-nav-footer">
      <a href="https://mersus.ie/terms-conditions/" target="_blank" rel="noopener"> Terms & Conditions </a> <br>
      <div> <a href="mailto:hello@mersus.ie" style="color:inherit; text-decoration:none;"> Contact support </a>
      </div>
      <div style="opacity:0.6;">© Mersus Technologies</div>
    </div>
  </div>
  <div class="aa-sidebar-backdrop" (click)="closeNav()"></div>
  <div class="aa-main">
    <div class="aa-topbar">
      <button class="aa-topbar-menu" (click)="toggleNav()" aria-label="Toggle navigation">
        <svg class="icon">
          <use href="#icon-menu-2"></use>
        </svg>
      </button>
      <!-- Light (the default) ↔ dark -->
      <button type="button" class="aa-theme-toggle" (click)="toggleTheme()" [attr.aria-label]="themeLabel" [title]="themeLabel">
        <svg class="icon">
          <use [attr.href]="themeIcon"></use>
        </svg>
      </button>
      <div class="user-menu" (click)="toggleUserMenu()">
        <div class="avatar">{{ userInitial }}</div>
        {{ userName }}
        <svg class="icon">
          <use href="#icon-chevron-down"></use>
        </svg>
        @if (userMenuOpen) {
        <div class="aa-user-dropdown" (click)="$event.stopPropagation()">
          @if (myDetailsRoute) {
          <a type="button" class="aa-user-dropdown-item" [routerLink]="myDetailsRoute" (click)="userMenuOpen = false">
            <svg class="icon">
              <use href="#icon-writing"></use>
            </svg>My details
          </a>
          }
          <button type="button" class="aa-user-dropdown-item" (click)="logOut()">
            <svg class="icon">
              <use href="#icon-logout"></use>
            </svg>Log out
          </button>
        </div>
        }
      </div>
    </div>
    <div class="aa-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>